//to hold entry info- what food was ate, what exercise was done, etc

import type { EntryAttributeDB } from "../DexieDB";
import Helpers from "../Helpers";

//should have other properties- for mood, rating 1-10, or 1-5, etc. For exercise, duration/ start time and end time.
export class EntryDB 
{
    id!: string;
    id_user!:string;
    id_cat!:string;
    id_item_type!:string;
    // item_type?:string="";
    timestamp!:number;
    date_updated!: Date;
    date_finished: Date|undefined;
    attributes:Array<EntryAttributeDB>;
    has_duration:boolean=false; //for if the entry has a duration/ will keep track of time passed
    tracking:boolean=false;
    constructor(obj:any)
    {
        this.attributes = new Array();
        //this allows us to copy all the variables/ proporties from a generic object to our current object (without haviung to do it manually, one by one)
        //BUG: this will copy all properties from the other object over, not just the ones that should be copied over
        // Object.assign(this, obj);
        Helpers.CopyObject(this, obj);

        //generate timestamp from date
        if(!this.timestamp&&this.date_updated)
            this.timestamp=this.date_updated.getTime();
    }
    IsEqual(other_entry:any)
    {
        let is_equal=true;
        for (var prop in this) 
        {
            //@ts-ignore
            if(prop==undefined||this[prop]==="undefined"||this[prop]===undefined)//if this prop is undefined... don't use it... javascript still does
                continue;
            if (other_entry.hasOwnProperty(prop))
            {
                if(this[prop] instanceof Date) //dates cant be compared/ bug as part of javascript official
                {
                    // continue;
                    //eh, it works- but it's already updating date in database wrong while testing, so not useful right now

                    //shouldn't compare timestamps- goes to millisecond accuracy- but we only store down to seconds- so it'll always be different if comparing ms
                    //@ts-ignore
                    let this_date = (this[prop] as Date);
                    //@ts-ignore
                    let other_date = (other_entry[prop] as Date);


                    // let this_date = (this[prop] as Date).getTime();
                    // let other_date = (other_entry[prop] as Date).getTime();
                    // if( this_date!= other_date )                
                    if(this_date.getFullYear() != other_date.getFullYear() || this_date.getMonth() != other_date.getMonth() || this_date.getDate() != other_date.getDate()||
                        this_date.getHours() != other_date.getHours() || this_date.getMinutes() != other_date.getMinutes() || this_date.getSeconds() != other_date.getSeconds()
                    )
                    {
                        console.log("Entry DB, prop ", prop," this: ", this[prop], "other: ", other_entry[prop], "for this: ", this, "and other : ",other_entry);
                        is_equal=false;
                        break;
                    }
                }
                else if(this[prop] != other_entry[prop])                
                {
                    console.log("Entry DB, prop ", prop," this: ", this[prop], "other: ", other_entry[prop], "for this: ", this, "and other : ",other_entry);
                    is_equal=false;
                    break;
                }
            }
        }
        return is_equal;
    }
    
}

export default class Entry extends EntryDB
{
    // id!:Number;
    item_type!:string; //to get from item types- stored as name in item types
    // date_updated!:Date;
    // date_finished!:Date;

    // id_item_type!:Number;
    // id_cat!:Number;
    
    // constructor(id:number, name:string, date_updated?:Date)
    constructor(obj:any)
    {
        super({});//if we actually pass the object using super, it will only copy over the variables on the parent class- not the current class, so have to do it again
        
        // Object.assign(this, obj);
        Helpers.CopyObject(this, obj);

        // super(obj)

        // console.log("created new entry, ", "this.item_type: ", this.item_type, "obj.item_type: ", obj.item_type);
        // this.id=id;
        // if(!this.item_type)
        //     this.item_type=obj.item_type;
        if(!this.item_type && !obj.blank)
            this.item_type = "Haven't gotten a entry item_type yet";
        if(!this.date_updated)
            this.date_updated = new Date();

        //generate timestamp from date
        if(!this.timestamp)
            this.timestamp=this.date_updated.getTime();

        if(!this.attributes)
            this.attributes = [];

        return this;
        // this.date_updated=date_updated;
        // console.log("created new entry, with date: ", this.date_updated, "and as string: ", this.date_updated.toString(), "this.item_type: ", this.item_type);
    }
    Assign(obj:any)
    {
        Helpers.CopyObject(this, obj);
    }
}